
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const LocationsCTA = () => {
  return (
    <section 
      className="relative py-16 bg-brand-charcoal-gray text-white overflow-hidden mt-12"
      style={{
        backgroundImage: `url('/lovable-uploads/05712f55-6608-4d58-b71e-fc4dd31ec82a.png')`,
        backgroundSize: '200px 200px',
        backgroundRepeat: 'repeat',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-brand-charcoal-gray/90"></div>
      
      <div className="relative container mx-auto px-4 text-center z-10">
        <h2 className="text-3xl font-bold mb-6">Ready to Get Started?</h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto">
          Contact us today for a free consultation and let us help you with all your roofing needs.
        </p>
        <Link to="/contact">
          <Button size="lg" className="bg-brand-safety-orange hover:bg-brand-safety-orange/90 text-white font-semibold">
            Get Free Estimate <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default LocationsCTA;
